import type { ReactNode } from "react";
import { ApiRequestError } from "../api/client";
import { useT } from "../state/session";
import type { TranslationKey } from "@veycue/i18n";

/**
 * Stany puste i błędy jako osobne komponenty. W produkcie, którego obietnicą jest
 * spokój, „nic tu nie ma" musi wyglądać jak dobra wiadomość, a nie jak awaria (§44).
 */
export function EmptyState({ title, description }: { title: string; description?: string }) {
  return (
    <div className="empty">
      <h3>{title}</h3>
      {description && <p>{description}</p>}
    </div>
  );
}

export function ErrorState({ error }: { error: unknown }) {
  const { t } = useT();

  if (error instanceof ApiRequestError) {
    // Kod błędu z API jest kluczem tłumaczenia — komunikaty backendu (po angielsku)
    // służą logom, użytkownik widzi tekst w swoim języku.
    const key = `error.${error.error.code}` as TranslationKey;
    return (
      <div className="error">
        <strong>{t(key)}</strong>
        {error.error.correlationId && <small>ID: {error.error.correlationId}</small>}
      </div>
    );
  }

  return (
    <div className="error">
      <strong>{t("error.internal_error")}</strong>
    </div>
  );
}

export function Loading() {
  const { t } = useT();
  return <p className="muted">{t("common.loading")}</p>;
}

export function Page({
  title,
  lead,
  children,
}: {
  title: string;
  lead?: string;
  children: ReactNode;
}) {
  return (
    <>
      <h1 className="page__title">{title}</h1>
      {lead && <p className="page__lead">{lead}</p>}
      {children}
    </>
  );
}
